import View from './View';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');

  addHandlerClick(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--inline');
      if (!btn) return;

      const goToPage = +btn.dataset.goto;
      handler(goToPage);
    });
  }

  _previousBtnContainer(markup) {
    return `<div class="page--nums page__num--1">
      ${markup}
          </div>`;
  }

  _midTxtContainer(markup) {
    return `<div class="page--nums page__num--2">
    ${markup}
    </div>`;
  }

  _nextBtnContainer(markup) {
    return `
    <div class="page--nums page__num--3">
    ${markup}
    </div>`;
  }

  _generatePreviousBtnMarkup(curPage) {
    return `
        <button data-goto="${
          curPage - 1
        }" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
                <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${curPage - 1}</span>
        </button>`;
  }

  _generateTotPagesMarkup(curPage, numPages) {
    return `
    <p class="txt--inline pagination__btn--mid">
      <span>Page ${curPage} of ${numPages}</span>
    </p>`;
  }

  _generateNextBtnMarkup(curPage) {
    return `
        <button data-goto="${
          curPage + 1
        }" class="btn--inline pagination__btn--next">
            <span>Page ${curPage + 1}</span>
            <svg class="search__icon">
                <use href="${icons}#icon-arrow-right"></use>
            </svg>
        </button>`;
  }

  _generateMarkup() {
    const curPage = this._data.page;

    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );

    // Page 1, and there are other pages
    if (curPage === 1 && numPages > 1) {
      return `
      ${this._previousBtnContainer('')}
      ${this._midTxtContainer(this._generateTotPagesMarkup(curPage, numPages))}
      ${this._nextBtnContainer(this._generateNextBtnMarkup(curPage))}`;
    }

    //Last page
    if (curPage === numPages && numPages > 1) {
      return `
      ${this._previousBtnContainer(this._generatePreviousBtnMarkup(curPage))}
      ${this._midTxtContainer(this._generateTotPagesMarkup(curPage, numPages))}
      ${this._nextBtnContainer('')}`;
    }

    //Other page
    if (curPage < numPages) {
      return `
      ${this._previousBtnContainer(this._generatePreviousBtnMarkup(curPage))}
      ${this._midTxtContainer(this._generateTotPagesMarkup(curPage, numPages))}
      ${this._nextBtnContainer(this._generateNextBtnMarkup(curPage))}`;
    }

    // Page 1, and there are No other pages
    return '';
  }
}

export default new PaginationView();
